/**
 * RepLinkDispatcher — handles both legacy review tokens AND the new
 * Representative slug links under the SAME `/r/:param` URL space.
 *
 * Disambiguation rule (no DB call needed):
 *   • Review tokens are LONG (>20 chars, JWT or UUID).
 *   • Rep slugs are short kebab-case `[a-z0-9-]{1,60}`.
 *
 * Behaviour:
 *   • Review token → renders the existing <PublicReview /> page.
 *   • Rep slug    → 302-redirect to /register?rep={slug} so the
 *                   downstream signup flow can read the param and
 *                   persist attribution.
 *
 * This keeps both campaigns alive without breaking any in-the-wild
 * review links that Marcelo may have already sent to customers.
 */
import { Navigate, useParams } from "react-router-dom";
import PublicReview from "@/pages/PublicReview";

const SLUG_RE = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export default function RepLinkDispatcher() {
  const { token } = useParams();
  const looksLikeRepSlug =
    token && token.length <= 60 && SLUG_RE.test(token);

  if (looksLikeRepSlug) {
    // Preserve any pre-existing query string the operator might
    // have appended (?utm_source=…) by passing through window.location.
    const existingQs = window.location.search;
    const sep = existingQs ? "&" : "?";
    return (
      <Navigate
        to={`/register${existingQs}${sep}rep=${encodeURIComponent(token)}`}
        replace
      />
    );
  }

  // Long token → treat as legacy review link.
  return <PublicReview />;
}
